<template>
  <div class="footer">
    <div class="container">
      <!-- <ul class="link-block">
        <li>关于我们</li>
        <li>服务声明</li>
        <li>意见反馈</li>
        <li class="last">联系我们</li>
      </ul> -->
      <!-- <p class="img-block1">
        <img src="../assets/images/footer-phonenum.jpg"/>
      </p> -->
      <p class="footer-desc">《互联网药品信息服务资格证书》编号：（川）-非经营性-2021-0035   &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   ICP备案号：蜀ICP备2021003230号</p>
<p class="footer-desc">公司地址：四川省成都市高新区永丰路47号。</p>
<p class="footer-desc">本网站未发布麻醉药品、精神药品、医疗用毒性药品、放射性药品、戒毒药品和医疗机构制剂的产品的交易。</p>
<p class="footer-desc">本公司网站不得发布未经国家批准的药品广告信息。</p>

      <p class="footer-desc">本站信息仅供参考，不能作为诊断及医疗的依据<i></i>本站如有转载或引用文章设计版权问题，请速与我们联系</p>
      <p class="footer-desc">Copyright © 2020 all rights reserved</p>
      <p><img src="../assets/images/footer-police.jpg" /></p>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    },
    methods: {
      // open1 () {
      //   this.$notify.info({
      //     title: '法律声明',
      //     message: '此仅为个人练习开源模仿项目，仅供学习参考，承担不起任何法律问题'
      //   })
      // }
    },
    components: {
    },
    created(){
      // this.open1();
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  .footer {
    // height: 350px;
    padding: 50px 0 20px;
    // border-top: 1px solid #e6e6e6;
    background: #fff;
    text-align: center;
    .link-block{
      display: flex;
      color: #0084C4;
      li{
        font-size: 14px;
        padding: 0 30px;
        background: url('../assets/images/dash.png')no-repeat right center;
        background-size: 3px auto;
      }
      .last{
        background: none;
      }
    }
    .img-block1{
      padding: 15px 0;
      img{
        width: 160px;
      }
    }
    .footer-desc{
      color: #909399;
      font-size: 13px;
      text-align: center;
      padding: 5px 0;
    }
  }
  .container {
    margin: 0 auto;
    display: inline-block;
  }
  
  
</style>



// WEBPACK FOOTER //
// src/common/footer.vue